// iPadOS 13+ reports a Mac user agent: tell it apart by touch support
export const isIOSDevice = () => {
    if (typeof navigator === 'undefined') {
        return false;
    }

    return (
        /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
};



// WEBPACK FOOTER //
// ./src/utils/deviceUtils.js